import type { Roles } from '@innovamat/radiance-utils';

export type CookiesUser = {
  id: string;
  email: string;
  roles: Roles[];
  school: string;
  crmId: string | null;
  region: string;
  locale: string;
  name: string;
  fullName: string;
  familyName: string;
  accessToken: string;
  refreshToken: string;
};

export type OrganizationResponse = {
  id: string;
  availableLanguages: string[];
  language: string;
  location: string;
  name: string;
  operativeRegion: string;
  platformEnabled: boolean;
  region: string;
  academicYearId: string;
  currency: string;
};

export type Organization = {
  id: string;
  location: string;
  academicYearId: string;
  currency: string;
  name: string;
  standard: string;
  startDate: string;
  endDate: string;
  upgradePeriod: number;
};

export type User = {
  id: string;
  crmId: string | null;

  email: string;
  roles: Roles[];

  organizationId: string;
  organizationName: string;
  organization?: Organization;

  region: string;
  physicalRegion: string;

  locale: string;
  name: string;
  fullName: string;
  familyName: string;

  studentData?: StudentData;
};

export type StudentData = {
  classroomId: string;
  classroomName: string;
  courseId: string;
  courseOrder: number;
};

export type SettingsResposne = {
  attributes: {
    email: string;
    firstName: string;
    lastLogin: Date;
    lastName: string;
    phoneNumber: string | null;
    positions: string[];
    roles: Roles[];
  };
  id: string;
};

export type SettingsValues = {
  id: string;
  email: string;
  firstName: string;
  lastLogin: Date;
  lastName: string;
  phoneNumber: string | null;
  positions: string[];
  roles: Roles[];
  schoolPositions: string[];
};

export type EditSettingsValues = {
  settings: {
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    positions: string[];
  };
  language: string;
};

export const SETTINGS_TAB_TYPES = [
  'PersonalData',
  'Password',
  'Email',
  'SchoolData',
  'Language',
] as const;

export type SettingsTabType = (typeof SETTINGS_TAB_TYPES)[number];

export const getAvailableSettingsTabs = ({
  isLeadOrParent,
  isPasswordExpired,
  showLanguageSelector,
}: {
  isLeadOrParent?: boolean;
  isPasswordExpired?: boolean;
  showLanguageSelector?: boolean;
}): SettingsTabType[] => {
  const items = [
    !isPasswordExpired ? { key: 'PersonalData' } : undefined,
    { key: 'Password' },
    !isLeadOrParent && !isPasswordExpired ? { key: 'Email' } : undefined,
    !isLeadOrParent && !isPasswordExpired ? { key: 'SchoolData' } : undefined,
    !isPasswordExpired && showLanguageSelector
      ? { key: 'Language' }
      : undefined,
  ];
  return items
    .filter((item): item is { key: SettingsTabType } => Boolean(item))
    .map((item) => item.key);
};
